export class LaboratoryHttpHeaderModel {
  public lastNonFreeSubscriptionProductType: string | null | undefined;
  public lastSubscriptionEndDate: string | null | undefined;
  public storageCapacityLimit: number | null | undefined;
  public storageUsage: number | null | undefined;
  public subscriptionEndDate: string | null | undefined;
  public suspendedFlag: boolean | undefined;

  public constructor(
    /**
     * The subscription end date of the current subscription.
     * We define "current subscription" as the subscription that is not disabled and with StartDate <= utcNow < EndDate.
     * If there is no current subscription, CurrentSubscriptionEndDate is null.
     */
    subscriptionEndDate: string | null | undefined,

    /**
     * The last non disabled subscription end date.
     * Please note that a laboratory could have no current subscription end date but a last subscription end date.
     */
    lastSubscriptionEndDate: string | null | undefined,

    /**
     * The product type of the last non free and not disabled subscription.
     */
    lastNonFreeSubscriptionProductType: string | null | undefined,
    storageCapacityLimit: number | null | undefined,
    storageUsage: number | null | undefined,
    suspendedFlag: boolean | undefined,
  ) {
    this.lastNonFreeSubscriptionProductType = lastNonFreeSubscriptionProductType;
    this.lastSubscriptionEndDate = lastSubscriptionEndDate;
    this.storageCapacityLimit = storageCapacityLimit;
    this.storageUsage = storageUsage;
    this.subscriptionEndDate = subscriptionEndDate;
    this.suspendedFlag = suspendedFlag;
  }
}
